<template>
  <div class="ifxv2-subaccount-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub"
          ><i class="el-icon-files"></i> IFXv2 Sub-accounts</span
        >
      </div>
      <div>
        <el-form :inline="true" class="search-area" @submit.native.prevent>
          <el-form-item>
            <el-input
              v-model="keyword"
              placeholder="Name / Member code / Plus UID"
              clearable
              style="width: 260px"
              @keyup.enter.native="search()"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="status" placeholder="All status" clearable style="width: 160px">
              <el-option
                v-for="item in statusOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search()"
              >Search</el-button
            >
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="tableData" border>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="subaccount-detail">
                <div><b>Enduser ID:</b> {{ props.row.enduserId }}</div>
                <div><b>Request ID:</b> {{ props.row.requestId || "-" }}</div>
                <div><b>Client ID:</b> {{ props.row.clientId || "-" }}</div>
                <div><b>Sub-account ID:</b> {{ props.row.subAccountId || "-" }}</div>
                <div><b>Account ID:</b> {{ props.row.accountId || "-" }}</div>
                <div><b>Updated:</b> {{ props.row.updatedDate || "-" }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdDate"
            label="Date"
            width="160"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="membercode"
            label="Member code"
            width="130"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="plusuid"
            label="Plus UID"
            width="150"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="Name"
            min-width="180"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="entityType"
            label="Type"
            width="110"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            width="110"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag size="mini" :type="statusTagType(scope.row.status)">{{
                scope.row.status
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="Account no. / Sort code"
            width="170"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.accountnumber || "-" }}</div>
              <div>{{ scope.row.sortcode || "-" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="IBAN / BIC"
            min-width="200"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.iban || "-" }}</div>
              <div>{{ scope.row.bicswift || "-" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="reason"
            label="Reason"
            min-width="200"
            header-align="center"
            align="left"
          >
            <template slot-scope="scope">
              <span class="text-red">{{ scope.row.reason }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            width="170"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                :loading="actionID === scope.row.id"
                :disabled="!scope.row.requestId"
                @click="checkStatus(scope.row)"
                >View</el-button
              >
              <el-button
                v-if="canResend(scope.row.status)"
                type="warning"
                size="mini"
                :loading="actionID === scope.row.id"
                @click="resend(scope.row)"
                >Resend</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination-subaccount"
          @size-change="setPageSize"
          @current-change="setPage"
          :current-page.sync="page"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItem"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getIfxv2SubAccounts,
  checkIfxv2SubAccountStatus,
  resendIfxv2SubAccount,
} from "@/api/ifxv2-subaccount";

export default {
  data() {
    return {
      keyword: "",
      status: "",
      statusOptions: ["pending", "accepted", "active", "rejected", "failed", "error"],
      tableData: [],
      loading: false,
      actionID: "",
      pageSize: 20,
      page: 1,
      totalItem: 0,
    };
  },
  methods: {
    getSubAccounts() {
      this.loading = true;
      let query = {
        keyword: this.keyword,
        status: this.status,
        page: this.page,
        items_per_page: this.pageSize,
      };
      getIfxv2SubAccounts(query).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.totalItem = data.totalItem;
          this.tableData = data.records;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    search() {
      this.page = 1;
      this.getSubAccounts();
    },
    // pull the request status from IBANQ; an error shows the reason
    checkStatus(row) {
      this.actionID = row.id;
      // a failed answer is shown by the request interceptor
      checkIfxv2SubAccountStatus(row.id).then(({ result, data }) => {
        this.actionID = "";
        if (!result) {
          return;
        }
        this.replaceRow(data);
        if (data.reason) {
          this.$message.warning(`${data.status}: ${data.reason}`);
        } else {
          this.$message.success(`Status: ${data.status}`);
        }
      }).catch(() => {
        this.actionID = "";
      });
    },
    resend(row) {
      this.$confirm(`Send the sub-account request of ${row.name} to IBANQ again?`, "Resend", {
        type: "warning",
      }).then(() => {
        this.actionID = row.id;
        resendIfxv2SubAccount(row.id).then(({ result, data }) => {
          this.actionID = "";
          if (!result) {
            return;
          }
          this.replaceRow(data);
          if (data.status === "error") {
            this.$message.error(data.reason || "Resend failed");
          } else {
            this.$message.success(`Status: ${data.status}`);
          }
        }).catch(() => {
          this.actionID = "";
        });
      }).catch(() => {});
    },
    replaceRow(data) {
      const index = this.tableData.findIndex((item) => item.id === data.id);
      if (index >= 0) {
        this.$set(this.tableData, index, data);
      }
    },
    canResend(status) {
      return ["error", "rejected", "failed"].indexOf(status) >= 0;
    },
    statusTagType(status) {
      if (status === "active") {
        return "success";
      }
      if (status === "rejected" || status === "failed" || status === "error") {
        return "danger";
      }
      if (status === "accepted") {
        return "";
      }
      return "info";
    },
    setPage(val) {
      this.page = val;
      this.getSubAccounts();
    },
    setPageSize(val) {
      this.pageSize = val;
      this.getSubAccounts();
    },
  },
  created() {
    this.getSubAccounts();
  },
};
</script>

<style lang="scss">
.ifxv2-subaccount-container {
  .search-area {
    margin-bottom: 6px;
  }

  .subaccount-detail {
    line-height: 22px;
    padding: 0 20px;
  }

  .pagination-subaccount {
    margin-top: 10px;
  }
}
</style>
